export default {
  common: {
    // Header / global nav
    nav: {
      home: "Home",
      find_offer_help: "Find / Offer Help",
      celebrate: "Celebrate a Life",
      family_tree: "Family Tree",
      events: "Events",
      civic_reports: "Civic Reports",
      neighborhood_pulse: "Neighborhood Pulse",
      weather: "Weather",
      nature: "Nature",
      marketplace: "Marketplace",
      news: "News",
      causes: "Causes",
      more: "More",
    },
    // Header buttons
    header: {
      sign_in: "Sign in",
      join: "Join Social Pulse",
      language: "Language",
      search: "Search",
    },
    // Top brand tagline
    tagline: "Connecting Communities · Empowering Lives · Building Social Capital",
    // Locality bar / country picker
    locality: {
      viewing_from: "You're viewing from",
      help_improve: "Help us enhance and improve your location",
      filter_by_country: "Filter by country",
      change: "Change",
      set_your_location: "Set your location",
      set_your_location_hint: "— tap to personalize",
    },
    // Buttons used across the app
    actions: {
      submit_cause: "Submit a Cause / Plea",
      make_donation: "Support Social Pulse Global Initiatives — Make a Donation",
      browse_all: "Browse all sections",
      read_more: "Read more",
      learn_more: "Learn more",
      submit: "Submit",
      cancel: "Cancel",
      save: "Save",
    },
    // News page
    news: {
      title: "Your Daily Briefing.",
      submit_news: "Submit News",
      archive: "Archive",
      weather_nature: "Weather & Nature",
      play_briefing: "Play daily briefing",
      play_briefing_hint: "Listen to the top {{count}} stories · ~{{minutes}} min · in your language",
      read_original: "Read Original",
      view_brief: "View brief",
      also_reported_by: "Also reported by:",
      translate: "Translate",
      listen: "Listen",
      stop: "Stop",
    },
  },
};
